import PageHeader from './Index.vue'

PageHeader.install = function(Vue) {
  Vue.component(PageHeader.name, PageHeader)
}

export default PageHeader
